import { render } from "./add-form.vue?vue&type=template&id=027baf72&scoped=true"
import script from "./add-form.vue?vue&type=script&lang=js"
export * from "./add-form.vue?vue&type=script&lang=js"

import "./add-form.vue?vue&type=style&index=0&id=027baf72&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027baf72"]])

export default __exports__